enum FieldType {
  String = "string",
  Number = "number",
  Boolean = "boolean",
  DateTime = "datetime-local",
  Date = "date",
  Project = "project",
  Service = "service",
  MessageType = "message-type",
  FunctionResult = "function-result",
}

export default FieldType;
